import React from 'react'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import { UsersListPagination } from '../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { Spinner } from 'react-bootstrap'

interface Props {
  total: any
  loading: any
  tpvs: any
  listOptions: any
  updateRowsPerPage: any
  updatePage: any
  page: any

}

const DashboardList = ({ total, loading, tpvs, updateRowsPerPage, page, updatePage, listOptions }: Props) => {

  return (
    <div className='card card-xxl-stretch mb-5 mb-xl-8' style={{ borderRadius: '12px' }}>
      <div className='card-header border-0 rounded-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Total Enrollments</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            <strong className='text-dark'>{total}</strong> Enrollments
          </span>
        </h3>
      </div>
      <KTCard>
        <div className='card card-custom'>
          <KTCardBody className='px-9 py-0 min-h-400px'>
            {total !== 0 ? (
              <div className='table-responsive-xxl'>
                {loading ? (
                  <div className="text-center">
                    <Spinner animation="border" className="text-gray-600 text-center" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>) : (
                  <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th className='header_title'>Agent Name</th>
                        <th className='header_title'>Total Enrollments</th>
                        <th className='header_title'>Passed TPVs</th>
                        <th className='header_title'>Failed TPVs</th>
                        <th className='header_title'>Pending TPVs</th>
                        <th className='header_title'>Incomplete TPVs</th>
                        <th className='header_title'>Conversion Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tpvs?.map((eachTpv: any) => {
                          return (
                            <tr className='border-bottom-2' style={{ cursor: 'pointer' }}>
                              <td className='name'>{eachTpv.agentName}</td>
                              <td className='content'>{eachTpv.totalTpv}</td>
                              <td className='content'>{eachTpv.tpvPassed}</td>
                              <td className='content'>{eachTpv.tpvFailed}</td>
                              <td className='content'>{eachTpv.tpvPending}</td>
                              <td className='content'>{eachTpv.tpvIncomplete}</td>
                              <td className='text-gray-600 fs-6 fw-semibold px-5'>{eachTpv.tpvConversionRate}</td>
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            ) : (<div className="fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center">No Results Found</div>)}
          </KTCardBody>
          {total !== 0 ? (
            <div className='card-footer border-0'>
              <UsersListPagination
                page={page}
                total={total}
                updatePage={updatePage}
                recordsPerPage={(e: any) => { updateRowsPerPage(parseInt(e)) }}
                rowsPerPage={listOptions.perPage}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </KTCard>
    </div>
  )
}


export { DashboardList }
